import React, { useEffect } from 'react'

export function RuModal({ title, subtitle, tone = '', footer, children, onClose, width = 640 }) {
  useEffect(() => {
    if (!onClose) return
    const h = (e) => { if (e.key === 'Escape') onClose() }
    document.addEventListener('keydown', h)
    return () => document.removeEventListener('keydown', h)
  }, [onClose])
  return (
    <div className="ru-overlay" role="dialog" aria-modal="true">
      <div className="ru-modal" style={{ maxWidth: width }}>
        <div className={`ru-modal-head ${tone}`}>
          <div className="ru-modal-title">{title}</div>
          {subtitle && <div className="ru-modal-sub">{subtitle}</div>}
        </div>
        <div className="ru-modal-body">{children}</div>
        {footer && <div className="ru-modal-foot">{footer}</div>}
      </div>
    </div>
  )
}

export function RuQuestion({ index, text, hint, error, children }) {
  return (
    <div className="ru-q">
      <div className="ru-q-head">
        <span className="ru-q-num">{index}</span>
        <span className="ru-q-text">{text}<span className="ru-req">*</span></span>
      </div>
      <div className="ru-q-body">
        {children}
        {hint && <div className="ru-q-hint">{hint}</div>}
        {error && <div className="ru-q-error">{error}</div>}
      </div>
    </div>
  )
}

export function RuChoice({ name, label, checked, onChange, disabled }) {
  return (
    <label className={`ru-choice${checked ? ' checked' : ''}${disabled ? ' disabled' : ''}`}>
      <input type="radio" name={name} checked={!!checked} onChange={onChange} disabled={disabled} />
      <span className="ru-choice-dot" />
      <span>{label}</span>
    </label>
  )
}

export function RuChip({ ok, children }) {
  return <span className={`ru-chip ${ok ? 'ok' : 'bad'}`}>{ok ? '✓' : '✕'} {children}</span>
}
